require('../vendor/stacktable/stacktable.js');

$(document).ready(function() {
    // get table
    $('.convert-table-on-mobile table').each(function() {
        $(this).stacktable();
    });
});